import { shouldLogOutOnForbidden } from '@/lib/api/twoFactorEnrollment';
import { generalApi } from '@/lib/api/general';
import {
  dispatchCheckApiError,
  dispatchLogOut,
  MainContext,
} from '../actionsMain';
import { AxiosError } from 'axios';
import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';
import {
  CompanyWhitelistIpCreateRequestBody,
  CompanyWhitelistIpBulkCreateRequestBody,
  CompanyWhitelistIpUpdateNameRequestBody,
} from '@/interfaces/api/general/company';
import { commitAddNotification } from '../mutations';
import { defineMessages } from '@/lib/i18n';

const m = defineMessages({
  ipAddressDeleted: 'IPアドレスを削除しました',
});

export const actionGetCompanyWhitelistIp = async (
  context: MainContext,
  payload: {
    companyId: string;
  }
) => {
  try {
    return await generalApi.getCompanyWhitelistIp(payload.companyId);
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};

export const actionGetClientIp = async (context: MainContext) => {
  try {
    return await generalApi.getClientIp();
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    throw axiosError;
  }
};

export const actionCreateCompanyWhitelistIp = async (
  context: MainContext,
  payload: {
    payload: CompanyWhitelistIpCreateRequestBody;
    companyId: string;
  }
) => {
  const response = await generalApi.createCompanyWhitelistIp(
    payload.companyId,
    payload.payload
  );
  return response;
};

export const actionCreateCompanyWhitelistIpBulk = async (
  context: MainContext,
  payload: {
    payload: CompanyWhitelistIpBulkCreateRequestBody;
    companyId: string;
  }
) => {
  const response = await generalApi.createCompanyWhitelistIpBulk(
    payload.companyId,
    payload.payload
  );
  return response;
};

export const actionUpdateCompanyWhitelistIpName = async (
  context: MainContext,
  payload: {
    companyId: string;
    ipAddress: string;
    payload: CompanyWhitelistIpUpdateNameRequestBody;
  }
) => {
  try {
    const response = await generalApi.updateCompanyWhitelistIpName(
      payload.companyId,
      payload.ipAddress,
      payload.payload
    );
    return response;
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};

export const actionDeleteCompanyWhitelistIp = async (
  context: MainContext,
  payload: {
    companyId: string;
    ipAddress: string;
  }
) => {
  try {
    const response = await generalApi.deleteCompanyWhitelistIp(
      payload.companyId,
      payload.ipAddress
    );
    if (response) {
      commitAddNotification(context, {
        messageKey: m.ipAddressDeleted,
        color: 'success',
      });
    }
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};
